import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const fileState = (state: RootState) => state.files;

export const isFileCreating = createSelector(fileState, ({ fileCreating }) => fileCreating);
